import React, { useState, useEffect, Fragment } from "react";
import { TextField, InputAdornment, IconButton } from "@material-ui/core";
import { ArrowDropDown, Clear } from "@material-ui/icons";
import { SearchDialog } from "./SearchDialog";
const LABEL_FIELD_NAME = "name";
export const SearchListField = ({ renderItem, name, dataTest, label, service, value, error, helperText, disabled, onChange, onBlur, }) => {
    const [fieldText, setFieldText] = useState("");
    const [dialogOpenProps, setDialogOpenProps] = useState({
        isDialogOpen: false,
        initialSearchText: "",
    });
    useEffect(() => {
        let isMounted = true;
        // scenario 1: we are loading the page, we have a value so need to look up what the visible version of that value is
        if (value && !fieldText) {
            service
                .get(value)
                .then(response => isMounted && setFieldText(response[LABEL_FIELD_NAME] || value))
                // todo: do we swallow here?
                .catch(err => {
                console.error(`Error in SearchListField: ${name}`, err);
                isMounted && setFieldText(value);
            });
        }
        if (!value && fieldText) {
            // scenario 2: we have reset the field to blank from outside of the control e.g. dependent controls, a change in one control means this must be cleared
            setFieldText("");
        }
        // todo: scenario 3: if we are actively setting the field to a positive value from the outside, we need to be able to reload the label
        return () => {
            isMounted = false;
        };
    }, [value, service, fieldText, name]);
    const handleSelectionMade = (val) => {
        setDialogOpenProps({ isDialogOpen: false, initialSearchText: "" });
        if (val) {
            onChange({ currentTarget: { name, value: val.id } });
            setFieldText(val.label);
        }
    };
    return (React.createElement(Fragment, null,
        React.createElement(TextField, { variant: "outlined", "data-test": dataTest, name: name, disabled: disabled, value: fieldText, label: label, fullWidth: true, onClick: () => !disabled && setDialogOpenProps({ isDialogOpen: true, initialSearchText: "" }), onKeyPress: e => setDialogOpenProps({
                isDialogOpen: true,
                // if an alphanumeric character has been typed in the parent field, kick off the search with it
                initialSearchText: e.key.match(/^[A-Za-z0-9]{1}$/) ? e.key : "",
            }), error: error, helperText: helperText, onBlur: _ => onBlur({ name }), InputProps: {
                endAdornment: (React.createElement(InputAdornment, { position: "end" },
                    React.createElement(IconButton, { edge: "end", role: "button", onClick: e => {
                            e.stopPropagation();
                            if (fieldText)
                                handleSelectionMade({ id: "", label: "" });
                        }, disabled: disabled }, fieldText ? React.createElement(Clear, null) : React.createElement(ArrowDropDown, null)))),
            }, inputProps: {
                "data-value": value,
            } }),
        React.createElement(SearchDialog, { label: label, name: name, service: service, dialogOpenProps: dialogOpenProps, renderItem: renderItem, onSelectOrClose: handleSelectionMade })));
};
